import React from "react";

export default function DownloadIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 20 20" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1481_3595)">
        <path
          d="M10 0.625C8.1458 0.625 6.33324 1.17483 4.79153 2.20497C3.24982 3.23511 2.04821 4.69929 1.33863 6.41234C0.629062 8.1254 0.443406 10.0104 0.805142 11.829C1.16688 13.6475 2.05976 15.318 3.37088 16.6291C4.68199 17.9402 6.35246 18.8331 8.17103 19.1949C9.9896 19.5566 11.8746 19.3709 13.5877 18.6614C15.3007 17.9518 16.7649 16.7502 17.795 15.2085C18.8252 13.6668 19.375 11.8542 19.375 10C19.375 7.5136 18.3873 5.12903 16.6291 3.37087C14.871 1.61272 12.4864 0.625 10 0.625ZM10 18.125C8.39303 18.125 6.82214 17.6485 5.486 16.7557C4.14985 15.8629 3.10844 14.594 2.49348 13.1093C1.87852 11.6247 1.71762 9.99099 2.03112 8.41489C2.34463 6.8388 3.11846 5.39106 4.25476 4.25476C5.39106 3.11846 6.8388 2.34462 8.41489 2.03112C9.99099 1.71761 11.6247 1.87852 13.1093 2.49348C14.594 3.10844 15.8629 4.14984 16.7557 5.48599C17.6485 6.82214 18.125 8.39303 18.125 10C18.125 12.1549 17.269 14.2215 15.7452 15.7452C14.2215 17.269 12.1549 18.125 10 18.125Z"
          fill={filteredStyles.fill}
        />
        <path
          d="M11.4311 9.55625L10.6249 10.3688V5.625C10.6249 5.45924 10.559 5.30027 10.4418 5.18306C10.3246 5.06585 10.1657 5 9.9999 5C9.83413 5 9.67516 5.06585 9.55795 5.18306C9.44074 5.30027 9.3749 5.45924 9.3749 5.625V10.3688L8.56865 9.5625C8.44908 9.46011 8.29528 9.4066 8.13799 9.41268C7.98069 9.41876 7.83148 9.48396 7.72017 9.59527C7.60886 9.70658 7.54365 9.85579 7.53758 10.0131C7.5315 10.1704 7.585 10.3242 7.6874 10.4437L9.5624 12.3187C9.6795 12.4352 9.8379 12.5005 10.003 12.5005C10.1681 12.5005 10.3265 12.4352 10.4436 12.3187L12.3186 10.4437C12.421 10.3242 12.4745 10.1704 12.4685 10.0131C12.4624 9.85579 12.3972 9.70658 12.2859 9.59527C12.1746 9.48396 12.0254 9.41876 11.8681 9.41268C11.7108 9.4066 11.557 9.46011 11.4374 9.5625L11.4311 9.55625Z"
          fill={filteredStyles.fill}
        />
        <path
          d="M11.875 13.75H8.125C7.95924 13.75 7.80027 13.8158 7.68306 13.9331C7.56585 14.0503 7.5 14.2092 7.5 14.375C7.5 14.5408 7.56585 14.6997 7.68306 14.8169C7.80027 14.9342 7.95924 15 8.125 15H11.875C12.0408 15 12.1997 14.9342 12.3169 14.8169C12.4342 14.6997 12.5 14.5408 12.5 14.375C12.5 14.2092 12.4342 14.0503 12.3169 13.9331C12.1997 13.8158 12.0408 13.75 11.875 13.75Z"
          fill={filteredStyles.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1481_3595">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
